<template>
  <div>
    <span :class="status.icon" :style="{color: status.color }"></span>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "ProcessoStatusIcon",
    props: ['status']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Competencia/ProcessoStatusIcon.vue